/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findBlogs = () => (
    gql`
        query BlogsQuery($blogOptions: BlogOptions, $contentType: String!, $environment: String!) {
            findBlogs(contentType: $contentType, environment: $environment,blogOptions: $blogOptions){
                blogs{
                    uid
                    title
                    excerpt
                    image
                    contentType
                    dateModified
                    datePublished
                    url
                }
                total
                pages
            }
        }
    `
);

export default findBlogs;
